import { render, staticRenderFns } from "./MdrlAdd.vue?vue&type=template&id=55bc6172&scoped=true&"
import script from "./MdrlAdd.vue?vue&type=script&lang=js&"
export * from "./MdrlAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55bc6172",
  null
  
)

export default component.exports